export var InteractionType;
(function (InteractionType) {
    InteractionType["PRAISE"] = "praise";
    InteractionType["FEEDBACK"] = "feedback";
    InteractionType["DEBRIEF"] = "debrief";
})(InteractionType || (InteractionType = {}));
